This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div
    v-if="getUserInfo().permissionLevel !== 'student'"
    class="classroomPackagesPage"
  >
    <div class="pageContainer lg:grid-cols-10 md:grid-cols-7">
      <section class="lg:col-span-3 md:col-span-7">
        <MyClassrooms @updateClassroom="updateClassroom" />
      </section>
      <section class="col-span-4">
        <ClassroomBundles
          ref="classroomBundles"
          :activeClassroom="activeClassroom"
          @updateAvailableBundles="updateAvailableBundles"
          @removeBundle="removeBundle"
        />
      </section>
      <section class="col-span-1">
        <div class="switchItems">
          <img src="@/assets/images/icons/Switch.svg" alt="Switch items icon" />
        </div>
      </section>
      <section class="col-span-2">
        <AvailableBundles
          ref="availableBundles"
          :activeBundles="activeBundles"
          @useBundle="addBundle"
        />
      </section>
    </div>
  </div>
  <QuestionButton :wikiSubjects="this.wikiSubjects" />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import MyClassrooms from "@/components/classroomPackages/MyClassroomsBlock.vue";
import ClassroomBundles from "@/components/classroomPackages/ClassroomBundlesBlock.vue";
import AvailableBundles from "@/components/classroomPackages/AvailableBundlesBlock.vue";
import { classroom, bundle } from "@/utils/Types";
import { getUserInfo } from "@/utils/Functions";
import QuestionButton from "@/components/QuestionButton.vue";

@Options({
  mounted() {
    this.updateQuestionButton();
  },
  data() {
    return {
      activeClassroom: null,
      activeBundles: null,
      wikiSubjects: [],
    };
  },
  components: {
    MyClassrooms,
    ClassroomBundles,
    AvailableBundles,
    QuestionButton,
  },
  methods: {
    updateClassroom(c: classroom) {
      this.activeClassroom = c;
    },
    updateAvailableBundles(b: bundle[]) {
      this.activeBundles = b;
    },
    async removeBundle(b: bundle) {
      await this.$refs.availableBundles.addAvailableBundle(b);
    },
    async addBundle(b: bundle) {
      await this.$refs.classroomBundles.addBundle(b);
    },
    updateQuestionButton() {
      this.wikiSubjects.push(
        {
          wikiButton: { name: this.$t("wiki.classign"), item: "classignPage" },
        }

        //here you can add more page references
      );
    },
    getUserInfo,
  },
  props: ["activeClassroom", "activeBundles"],
})
export default class ClassroomPackages extends Vue {}
</script>

<style lang="scss">
@import "src/assets/stylesheets/pages/Packages.scss";
</style>
